<template>
  <div class="listFilter">
    <div class='bg-border'>

      <div class="flex between listFilter-cell">
        <!-- 城市 -->
        <div class="flex align filterStyle" @click.stop="onShowFilterCell(0)"><span
            :class="(filterIndex=='0'||(!(selProvinceIndex==0&&selCityIndex==0&&selAreaIndex==0)))?'clr-cyan':''">城市</span>
          <img src="../assets/icon-active.svg" class="listFilter-active" v-if="filterIndex=='0'">
          <img src="../assets/icon-normal.svg" class="listFilter-normal" v-else>
        </div>

        <!-- 筛选 -->
        <div class="flex align filterStyle" @click.stop="onShowFilterCell(1)"
          :class="(filterIndex=='1'||selScreenIndex!=-1)?'clr-cyan':''"><span>筛选</span>
          <img src="../assets/icon-active.svg" class="listFilter-active" v-if="filterIndex=='1'||selScreenIndex!=-1">
          <img src="../assets/icon-normal.svg" class="listFilter-normal" v-else>
        </div>
      </div>
      <div>
        <template v-if="show">
          <template v-if="filterIndex=='0'">
            <div class="flex">
              <div class="item" :style="'overflow-y: scroll;max-height:'+(Height-220)+'px'">
                <div v-for="(item,akey) in province" :key="akey"
                  :class="['city',selProvinceIndex==akey?'city-active':'']" @click.stop="getCity(item,akey,false)">
                  {{item.shortName}}</div>
              </div>
              <div class="item border-left-right" :style="'overflow-y: scroll;max-height:'+(Height-220)+'px'">
                <div v-for="(item,bkey) in city" :key="bkey" :class="['city',selCityIndex==bkey?'city-active':'']"
                  @click.stop="getArea(item,bkey,false)">{{item.shortName}}</div>
              </div>
              <div class="item" :style="'overflow-y: scroll;max-height:'+(Height-220)+'px'">
                <div v-for="(item,ckey) in area" :key="ckey" :class="['city',selAreaIndex==ckey?'city-active':'']"
                  @click.stop="onArea(item,ckey,false)">{{item.shortName}}</div>
              </div>
            </div>
          </template>
          <template v-if="filterIndex=='1'">
            <div class="pad-15" :style="'overflow-y: scroll;max-height:'+(Height-220)+'px'">
              <div class="flex wrap">
                <span v-for="(item,i) in screenList" :key="i" :class="['label-filter',item.selected?'span-active':'']"
                  @click="onScreen(item,i)">{{item.name}}</span>
              </div>
            </div>
          </template>
        </template>

        <div class="flex between" v-if="show"><span class="btn-normal" @click.stop="onReset">重置</span><span
            class="btn-normal btn-filter" @click.stop="onFilter">确定</span></div>
      </div>
    </div>
    <div class="filterMask" :style='"height:"+Height+"px"' @click.stop="onCancelFixed" v-if="show"></div>
  </div>
</template>

<script>
import {
  Toast
} from 'mint-ui';
import {
  getRegion,
} from '../service/api'
export default {
  name: 'ListFilter',
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      },
    },

  },
  data() {
    return {
      filterIndex: '',
      Height: document.documentElement.clientHeight,
      selProvinceIndex: 0, //选择省的index
      selCityIndex: 0, //选择市的index
      selAreaIndex: 0, //选择县级市的index
      selScreenIndex: sessionStorage.getItem('ScreenIndex') || -1, //选择筛选的index
      // provinceIndex: Number(sessionStorage.getItem('provinceIndex')) || 0, //地区控件默认省份的index
      // cityIndex: Number(sessionStorage.getItem('cityIndex')) || 0, //地区控件默认城市的index
      // areaIndex: Number(sessionStorage.getItem('areaIndex')) || 0, //地区控件默认县级市的index
      // 省市区
      province: [],
      city: [],
      area: [],
      // screenList:['个体咨询室','家庭咨询室','沙盘室','团体室','多功能室','助理服务'],
      screenList: [{
        'name': '个体咨询室',
        'selected': false,
      }, {
        'name': '家庭咨询室',
        'selected': false,
      }, {
        'name': '沙盘室',
        'selected': false,
      }, {
        'name': '团体室',
        'selected': false,
      }, {
        'name': '多功能室',
        'selected': false,
      }, {
        'name': '助理服务',
        'selected': false,
      }],
      selScreenList: [],//用于筛选选中的条件
      show: false, //展开筛选的条件
      body: {
        criteria: {
          provinceCode: '',
          cityCode: '',
          districtCode: '',
          typeList: []
        },
        page: {
          pageNo: 1,
          pageSize: 5
        }
      }
      // dictList:[]
    }
  },
  mounted() {
    // 获取市区
    this.getProvince()
    this.getCity({
      regionCode: sessionStorage.getItem('provinceId') || "110000"
    }, sessionStorage.getItem('ProvinceIndex') || 0, true)
    this.getArea({
      regionCode: sessionStorage.getItem('cityId') || "110100"
    }, sessionStorage.getItem('CityIndex') || 0, true)
  },
  methods: {
    getProvince(item) {
      getRegion({
        criteria: {
          parentCode: "100000"
          // level:2
        }
      }).then(res => {
        this.province = [{
          id: '',
          shortName: '不限',
          regionCode: ''
        }].concat(res.data.list)
        this.body.criteria.provinceCode = ""
      })
    },

    // 获取地级市数据
    getCity(item, index, flag) {
      if (index == 0 && !flag) {
        this.body.criteria.provinceCode = ""//省编码
        this.body.criteria.cityCode = ""//市编码
        this.body.criteria.districtCode = ""//区县编码
        //省份、地级市、县级市id默认初始化为0
        this.selProvinceIndex = 0
        this.selCityIndex = 0
        this.selAreaIndex = 0
        return
      }
      const self = this;
      getRegion({
        criteria: {
          // level:3
          parentCode: item.regionCode //默认北京
        }
      }).then(res => {
        this.city = [{
          id: '',
          shortName: '不限',
          regionCode: ''
        }].concat(res.data.list)
        this.selProvinceIndex = index
        //地级市跟县级市id默认初始化为0
        debugger
        self.selCityIndex = 0
        self.selAreaIndex = 0
        sessionStorage.setItem('CityIndex', "")
        sessionStorage.setItem('AreaIndex', "")
        //地级市跟县级市regionCode默认初始化为第一个对象的值
        // this.body.provinceId = item.regionCode
        self.body.criteria.provinceCode = item.regionCode
        // this.body.cityId = this.city[0].regionCode
        self.body.criteria.cityCode = ""
        self.body.criteria.districtCode = ""
        self.getArea(self.city[sessionStorage.getItem('CityIndex') || 1], sessionStorage.getItem('AreaIndex') ||
          0, true)
        if (flag) {
          self.body.criteria.provinceCode = sessionStorage.getItem('provinceId') || ""
        }
      })
    },

    // 获取县级市数据
    getArea(item, index, flag) {
      if (index == 0 && !flag) {
        this.body.criteria.cityCode = ""//市编码
        this.body.criteria.districtCode = ""//区县编码
        //省份、地级市、县级市id默认初始化为0
        this.selCityIndex = 0
        this.selAreaIndex = 0
        this.areaIndex = 0
        return
      }
      // sessionStorage.setItem('cityId', item.regionCode)
      getRegion({
        criteria: {
          // level:4
          parentCode: item.regionCode //默认北京
        }
      }).then(res => {
        this.area = [{
          id: '',
          shortName: '不限',
          regionCode: ''
        }].concat(res.data.list)
        debugger
        this.selCityIndex = index
        this.selAreaIndex = 0
        //县级市id默认初始化为0
        this.areaIndex = index
        //县级市regionCode默认初始化为第一个对象的值
        this.body.criteria.cityCode = item.regionCode
        this.body.criteria.districtCode = ""//区县编码
        // this.onArea()
        if (flag) {
          this.body.criteria.cityCode = sessionStorage.getItem('cityId') || ""
          this.selCityIndex = sessionStorage.getItem('CityIndex') || index
          this.selAreaIndex = sessionStorage.getItem('AreaIndex') || index
          this.body.criteria.districtCode = sessionStorage.getItem('countyId') || ""
        }
      })
    },

    // 操作县市级数据
    onArea(item, index, flag) {
      this.selAreaIndex = index
      this.body.criteria.districtCode = item.regionCode
      if (flag) {
        this.body.criteria.cityCode = sessionStorage.getItem('countyId') || ""
        this.selAreaIndex = sessionStorage.getItem('AreaIndex') || index
      }
    },

    // 筛选出列表
    onFilter() {
      debugger
      // 缓存城市选择数据
      if (this.filterIndex == 0) {
        sessionStorage.setItem('ProvinceIndex', this.selProvinceIndex)
        sessionStorage.setItem('CityIndex', this.selCityIndex)
        sessionStorage.setItem('AreaIndex', this.selAreaIndex)
        sessionStorage.setItem('provinceId', this.body.criteria.provinceCode)
        sessionStorage.setItem('cityId', this.body.criteria.cityCode)
        sessionStorage.setItem('countyId', this.body.criteria.districtCode)

      }

      if (this.filterIndex == 1) {
        sessionStorage.setItem('ScreenIndex', this.selScreenIndex)

        if (!this.body.criteria) {
          this.body.criteria = {}
        }
        this.body.criteria.typeList = this.selScreenList
      }
      this.show = false
      this.$emit('filter', this.body)
    },
    // 重置筛选
    onReset() {
      debugger
      if (this.filterIndex == 0) {
        this.body.criteria.provinceCode = ""//省编码
        this.body.criteria.cityCode = ""//市编码
        this.body.criteria.districtCode = ""//区县编码
        //省份、地级市、县级市id默认初始化为0
        this.selProvinceIndex = 0
        this.selCityIndex = 0
        this.selAreaIndex = 0
        sessionStorage.removeItem('ProvinceIndex')
        sessionStorage.removeItem('CityIndex')
        sessionStorage.removeItem('AreaIndex')
        sessionStorage.removeItem('provinceId')
        sessionStorage.removeItem('cityId')
        sessionStorage.removeItem('countyId')
        this.getProvince()
        this.getCity({
          // regionCode:  ""
          criteria: {
            regionCode: ""
          }
        }, 0, true)
      } else if (this.filterIndex == 1) {
        sessionStorage.removeItem('ScreenIndex')
        this.selScreenIndex = -1
        this.screenList = this.screenList.map(item => {
          return { ...item, selected: false }
        })
      }
      this.body = {
        page: {
          pageNo: 1,
          pageSize: 5
        },
        criteria: {
          provinceCode: '',
          cityCode: '',
          districtCode: '',
        }
      }
      // 重置缓存参数
      sessionStorage.setItem('body', JSON.stringify(this.body))
      this.show = false
      this.$emit('filter', this.body)
    },

    onShowFilterCell(key) {
      this.filterIndex = key
      this.show = true
      this.$emit('change', {
        type:"typeA",
        data:{

        }
      })
      this.$emit('change', {
         type:"typeB",
        data:{
        }
      })
    },
    onCancelFixed() {
      this.filterIndex = ''
      this.show = false
      this.$emit('cancelFixed', false)
    },
    onClose() {
      this.$emit('close')
    },
    // 筛选
    onScreen(item, i) {
      this.selScreenList = []
      if (!item.selected) {
        this.$set(item, 'selected', true)
      } else {
        this.$set(item, 'selected', false)
      }
      // this.selScreenList = this.screenList.filter(item => {
      //    return item && item.selected
      // })
      this.screenList.map(items => {
        if (items.selected) {
          this.selScreenList.push(items.name)
        }
      })
    },

  }
};

</script>

<style lang="stylus">
  @import '../stylus/components/listFilter.styl'

.align {
    justify-content: center;
    width: 50%;
}
.filterStyle{
  justify-content: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ListFilter.vue